import React, { useEffect, useState } from "react";
import GameBatchUpload from "./components/GameBatchUpload";
import VideoUpload from "./components/VideoUpload";
import PlaysList from "./components/PlaysList";
import "./App.css";

const APPS = {
  high_school: {
    ruleset: "high_school",
    shortLabel: "High School",
    title: "Video Evaluation - High School Rules",
    expertTitle: "High School Football Video Review Expert",
    cardTitle: "High School Football Video Review Expert",
    subtitle: "NFHS rulebook review for uploaded football plays.",
    intro: "Load a play and Dave will evaluate the video under high school football rules, confirming correct calls and detailing any missed or incorrect calls.",
    path: "/high-school",
  },
  college: {
    ruleset: "college",
    shortLabel: "College",
    title: "Video Evaluation - College Rules",
    expertTitle: "College Football Video Review Expert",
    cardTitle: "College Football Video Review Expert",
    subtitle: "NCAA rulebook review for uploaded college football plays.",
    intro: "Load a play and Dave will evaluate the video under NCAA college football rules, confirming correct calls and detailing any missed or incorrect calls.",
    path: "/college",
  },
  pro: {
    ruleset: "pro",
    shortLabel: "Pro",
    title: "Video Evaluation - Pro Rules",
    expertTitle: "Pro Football Video Review Expert",
    cardTitle: "Pro Football Video Review Expert",
    subtitle: "NFL rulebook review for uploaded professional football plays.",
    intro: "Load a play and Dave will evaluate the video under pro football rules, confirming correct calls and detailing any missed or incorrect calls.",
    path: "/pro",
  },
};

function resolveAppConfig() {
  const envRuleset = process.env.REACT_APP_RULESET;
  const routeText = `${window.location.pathname} ${window.location.hash}`.toLowerCase();
  let pathRuleset = "";
  if (routeText.includes("college")) pathRuleset = "college";
  if (routeText.includes("pro") || routeText.includes("nfl")) pathRuleset = "pro";
  if (routeText.includes("high-school") || routeText.includes("high_school") || routeText.includes("highschool")) {
    pathRuleset = "high_school";
  }
  return APPS[envRuleset] || APPS[pathRuleset] || null;
}

function buildPath(path) {
  return `#${path}`;
}

function FilmEvaluationChooser() {
  const apps = [APPS.high_school, APPS.college, APPS.pro];
  return (
    <div className="filmLanding">
      <div className="filmHero">
        <div className="filmHeroOverlay" />
        <div className="filmHeroContent">
          <p className="appEyebrow">Dave Systems Inc</p>
          <h1>Film Evaluation</h1>
          <p>
            Choose the video review expert for the rulebook that applies to your play.
          </p>
          <div className="expertGrid" aria-label="Film evaluation experts">
            {apps.map((app) => (
              <a key={app.ruleset} className="expertCard" href={buildPath(app.path)}>
                {app.cardTitle}
              </a>
            ))}
          </div>
        </div>
      </div>
      <section className="filmIntro">
        <div className="filmIntroMedia" aria-hidden="true" />
        <div className="filmIntroCopy">
          <h2>Video Evaluation is Here</h2>
          <p>
            Upload the play, select the applicable rule family, and Dave will review the clip against that rulebook.
          </p>
        </div>
      </section>
    </div>
  );
}

function App() {
  const [, setRouteTick] = useState(0);
  const [workflow, setWorkflow] = useState("batch");
  const appConfig = resolveAppConfig();

  useEffect(() => {
    const onRouteChange = () => setRouteTick((tick) => tick + 1);
    window.addEventListener("hashchange", onRouteChange);
    window.addEventListener("popstate", onRouteChange);
    return () => {
      window.removeEventListener("hashchange", onRouteChange);
      window.removeEventListener("popstate", onRouteChange);
    };
  }, []);

  if (!appConfig) {
    return <FilmEvaluationChooser />;
  }

  return (
    <div className="App appShell">
      <header className="appHeader">
        <div>
          <p className="appEyebrow">Dave Systems</p>
          <h1>{appConfig.title}</h1>
          <p>{appConfig.intro}</p>
        </div>
        <nav className="appNav" aria-label="Evaluation apps">
          <a href={buildPath(APPS.high_school.path)} className={appConfig.ruleset === "high_school" ? "active" : ""}>
            High School
          </a>
          <a href={buildPath(APPS.college.path)} className={appConfig.ruleset === "college" ? "active" : ""}>
            College
          </a>
          <a href={buildPath(APPS.pro.path)} className={appConfig.ruleset === "pro" ? "active" : ""}>
            Pro
          </a>
        </nav>
      </header>
      <main className="appMain">
        <div className="workflowTabs" aria-label="Evaluation workflow">
          <button
            type="button"
            className={workflow === "batch" ? "active" : ""}
            onClick={() => setWorkflow("batch")}
          >
            Full Game Batch
          </button>
          <button
            type="button"
            className={workflow === "single" ? "active" : ""}
            onClick={() => setWorkflow("single")}
          >
            Single Play
          </button>
        </div>
        {workflow === "batch" ? (
          <GameBatchUpload ruleset={appConfig.ruleset} />
        ) : (
          <>
            <VideoUpload ruleset={appConfig.ruleset} title={appConfig.expertTitle} />
            <PlaysList ruleset={appConfig.ruleset} />
          </>
        )}
      </main>
    </div>
  );
}   

export default App;
